// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hy-simple-calculator .hy-simple-calculator-section .hy-simple-calculator-line-item{padding:0 10px}
`, "",{"version":3,"sources":["webpack://./src/components/editors/PackagingEditor/SimpleCalculator.scss"],"names":[],"mappings":"AAAA,oFAGY,cAAe","sourcesContent":[".hy-simple-calculator {\n    .hy-simple-calculator-section {\n        .hy-simple-calculator-line-item {\n            padding: 0 10px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
